import { observer } from 'mobx-react-lite'
import { DeleteDependentDialog } from './index'
import type { DeleteDependentDialogViewModel } from './DeleteDependentDialogViewModel'
import { formatFullName } from '@/utils/full-name-util'

export interface DeleteDependentDialogContainerProps {
  vm: DeleteDependentDialogViewModel
}

/**
 * Container for the DeleteDependentDialog that wires up the view model.
 */
export const DeleteDependentDialogContainer = observer(
  function DeleteDependentDialogContainer({
    vm,
  }: DeleteDependentDialogContainerProps) {
    const dependent = vm.dependent
    const fullName = dependent
      ? formatFullName(
          dependent.personalInfo.firstName,
          dependent.personalInfo.middleInitial,
          dependent.personalInfo.lastName,
        )
      : ''

    return (
      <DeleteDependentDialog
        isOpen={vm.modal.showing}
        onClose={vm.cancel}
        fullName={fullName}
        isDeletePending={vm.delete.pending}
        onConfirmDeletePress={vm.delete}
      />
    )
  },
)
